import {
  IPAD_LANDSCAPE_PREVIEW_WIDTH_PX,
  IPAD_PORTRAIT_PREVIEW_WIDTH_PX,
  IPHONE_PREVIEW_WIDTH_PX,
  IPAD_PRO_11_M4_LANDSCAPE,
  IPAD_PRO_11_M4_PORTRAIT,
  IPHONE_16_PRO_BLACK_TITANIUM,
} from "./kioskDeviceSpecs"

/** Which device frame + preview width to use — layout markup is shared; only scale changes. */
export const KIOSK_IPHONE_FRAME = {
  spec: IPHONE_16_PRO_BLACK_TITANIUM,
  frameWidthPx: IPHONE_PREVIEW_WIDTH_PX,
} as const

export const KIOSK_IPAD_PORTRAIT_FRAME = {
  spec: IPAD_PRO_11_M4_PORTRAIT,
  frameWidthPx: IPAD_PORTRAIT_PREVIEW_WIDTH_PX,
} as const

export const KIOSK_IPAD_LANDSCAPE_FRAME = {
  spec: IPAD_PRO_11_M4_LANDSCAPE,
  frameWidthPx: IPAD_LANDSCAPE_PREVIEW_WIDTH_PX,
} as const
